import type { GridSize } from "../store/workspace.js";

export interface ChartSizePreset extends GridSize {
  id: "small" | "medium" | "large" | "wide";
  label: string;
  description: string;
}

export const CHART_SIZE_PRESETS: ChartSizePreset[] = [
  {
    id: "small",
    label: "Small",
    description: "Compact watchlist view",
    w: 4,
    h: 6,
  },
  {
    id: "medium",
    label: "Medium",
    description: "Balanced default",
    w: 6,
    h: 8,
  },
  {
    id: "large",
    label: "Large",
    description: "More chart detail",
    w: 8,
    h: 10,
  },
  {
    id: "wide",
    label: "Wide",
    description: "Full dashboard width",
    w: 12,
    h: 8,
  },
];

export const DEFAULT_CHART_SIZE = CHART_SIZE_PRESETS[1]!;
